module.exports = __webpack_public_path__ + "img/9clubs.8e0c822c.jpg";